import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 * Customs staff management service
 * !== 세관 직원 관리 service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/usr/cstmofcr`,
    api_ofcr: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/usr/cstm-ofcrs`,
    api_acrbt: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/acrdt`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0902001q: `${BASE.path}/ptli0902001q`, // Customs staff management list !== 세관직원관리 목록 ==!
    ptli0902002s: `${BASE.path}/ptli0902002s`, // Customs staff management registration !== 세관직원관리 등록 ==!
    ptli0902003s: `${BASE.path}/ptli0902003s`, // Customs staff management Modifying !== 세관직원관리 수정 ==!
    ptli0902004q: `${BASE.path}/ptli0902004q`, // Customs staff management details !== 세관직원관리 상세 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Get a list of Customs staff. !== 세관 직원 목록을 조회한다. ==!
    getCstmOfcrList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api_ofcr}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Get a excel list of Customs staff. !== 세관 직원 엑셀 목록을 조회한다. ==!
    getCstmOfcrExcelList: (data: any) => api.get(`${BASE.api_ofcr}/excel`, { params: comnUtils.toGetParams(data) }),

    // Select Customs staff details !== 세관 직원 상세 정보 조회 ==!
    getCstmOfcr: (usrDmnId: any) => api.get(`${BASE.api_ofcr}/${usrDmnId}`),

    // Select. the list of customs that can be changed.
    getUsrCstmList: (usrDmnId: any) => api.get(`${BASE.api_ofcr}/usr/cstm/${usrDmnId}`),

    // Create Customs staff !== 세관 직원 생성 ==!
    createCstmOfcr: (data: any) => api.post(`${BASE.api_ofcr}/new`, { ...data }),

    // Update Customs staff !== 세관 직원 수정 ==!
    updateCstmOfcr: (data: any) => api.post(`${BASE.api_ofcr}`, { ...data }),

    // Send Email !== 이메일 발송 ==!
    sendEmail: (data: any) => api.post(`${BASE.api_ofcr}/eml`, { ...data }),

    // Delete Customs staff !== 세관 직원 삭제 ==!
    deleteCstmOfcr: (usrDmnId: any) => api.delete(`${BASE.api_ofcr}/${usrDmnId}`),

    // Section search by customs, unit search by section !== 세관별 섹션 조회, 섹션별 유닛 조회 ==!
    getOrgzList: (data: any) => api.get(`${BASE.api_acrbt}/new-usr/cstm/orgz?`, { params: comnUtils.toGetParams(data) }),

    // Get a list of Customs Role. !== 세관 역할 목록을 조회한다. ==!
    getCstmRoleList: (data: any) => api.get(`${BASE.api_ofcr}/roles/cstm?`, { params: comnUtils.toGetParams(data) }),

    // Check TIN validity !== TIN 유효성을 체크한다. ==!
    getUsrTinInfo: (usrTin: any) => api.get(`${BASE.api_acrbt}/tin/cstm/${usrTin}`),

    // TIN Number Search !== TIN 번호 조회 ==!
    getTinNoLst: (tinNo: any, bizYn: any) => comnUtils.getCode({ area: "tinNo", keyword: tinNo, param2: bizYn }),

    // Check user registration application information !== 사용자 등록 신청 정보 조회 ==!
    getUsrRgsrAplyInfo: (data: any) => api.get(`${BASE.api_acrbt}/new-usr/cstm/${data.usrDmnId}/${data.cstmOfcrNo}`),

    // HR system employee number inquiry !== HR시스템 직원번호 조회 ==!
    getHrUsrInfo: (cstmOfcrNo: any) => api.get(`${BASE.api_acrbt}/hr-usr/cstm/${cstmOfcrNo}`),

    getInternalUserReport: (usrDmnId: string) => {
        return api.get(`${BASE.api_ofcr}/rprt/${usrDmnId}`, {
            responseType: "arraybuffer",
        });
    },
};

export const SF_CSTM_OFCR_SEARCH_FORM: TFormSchema = {
    id: "form_cstmOfcrSrch",
    schema: {
        usrNm: { type: "text", label: "L_NM" },
        usrDmnId: { type: "text", label: "L_USR_ID" },
        cstmOfcrNo: { type: "text", label: "L_CSTM_OFCR_NO" },
        arrUsrStatCd: { type: "checkbox", label: "L_USR_STAT", area: "comnCd", comnCd: "PTL0001" },
        cstmOfceCd: { type: "code", label: "L_CSTM_OFCE", area: "cstmCd", popupSize: "md" },
        cstmSctnCd: { type: "code", label: "L_CSTM_SCTN", area: "cstmOrgzCd" },
        cstmUnitCd: { type: "code", label: "L_CSTM_UNIT", area: "cstmOrgzCd" },
    },
};

export const SF_CSTM_OFCR_EXCEL_FORM: TFormSchema = {
    id: "form_cstmOfcrExcel",
    schema: {
        usrDmnId: { type: "text", label: "L_USR_ID" },
        usrNm: { type: "text", label: "L_NM" },
        cstmOfcrNo: { type: "text", label: "L_CSTM_OFCR_NO" },
        cstmSctnCdNm: { type: "text", label: "L_CSTM_SCTN" },
        cstmNm: { type: "text", label: "L_CSTM_OFCE" },
        cstmUnitCdNm: { type: "text", label: "L_CSTM_UNIT" },
        usrStatCdNm: { type: "text", label: "L_USR_STAT" },
    },
};

export const SG_CSTM_OFCR_LIST: TGridSchema = {
    id: "grid_btchInfoList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_USR_ID", binding: "usrDmnId", width: "15%" }] },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "15%" }] },
        { cells: [{ header: "L_CSTM_OFCR_NO", binding: "cstmOfcrNo", width: "15%" }] },
        { cells: [{ header: "L_CSTM_SCTN", binding: "cstmSctnCdNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_OFCE", binding: "cstmNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_UNIT", binding: "cstmUnitCdNm", width: "15%" }] },
        { cells: [{ header: "L_USR_STAT", binding: "usrStatCdNm", width: "10%" }] },
    ],
    body: [
        { cells: [{ binding: "usrDmnId" }] },
        { cells: [{ binding: "usrNm", align: "left" }] },
        { cells: [{ binding: "cstmOfcrNo" }] },
        { cells: [{ binding: "cstmSctnCdNm", align: "left" }] },
        { cells: [{ binding: "cstmNm", align: "left" }] },
        { cells: [{ binding: "cstmUnitCdNm", align: "left" }] },
        { cells: [{ binding: "usrStatCdNm" }] },
    ],
};

export const SF_CSTM_OFCR_INFO_FORM: TFormSchema = {
    id: "form_cstmOfcrInfo",
    schema: {
        fileGrpUuid: {
            type: "file",
            label: "L_CSTM_OFCR_PHTO",
            thumbnail: true,
            thumbnailWidth: 100,
            thumbnailHeight: 130,
            isPublic: true,
        },
        fileAtchGrpUuid: {
            type: "file",
            label: "L_ADD_ATCD_FILE",
            isPublic: true,
        },
        usrDmnId: { type: "text", label: "L_USR_ID" },
        usrNm: { type: "text", label: "L_CSTM_OFCR_NAME" },
        usrTin: {
            type: "text",
            label: "L_TIN",
            maxLength: 9,
            minLength: 7,
            pattern: { value: /[0-9]$/, message: "msg.ptl.00677" },
        },
        usrTelno: {
            type: "text",
            pattern: { value: /[0-9]$/, message: "msg.ptl.00677" },
            label: "L_CSTM_OFCR_TEL_NO",
        },
        usrEmlAddr: { type: "text", label: "L_CSTM_OFCR_EML" },
        cstmOfcrNo: {
            type: "text",
            label: "L_CSTM_OFCR_NO",
            pattern: { value: /[0-9]$/, message: "msg.ptl.00677" },
            maxLength: 10,
        },
        smsRcpnYn: {
            type: "radio",
            label: "L_SMS_RCPN_YN",
            options: [
                { label: "L_CD_YES", value: "Y" },
                { label: "L_CD_NO", value: "N" },
            ],
            viewType: "label",
        },
        emlRcpnYn: {
            type: "radio",
            label: "L_EML_RCPN_YN",
            options: [
                { label: "L_CD_YES", value: "Y" },
                { label: "L_CD_NO", value: "N" },
            ],
            viewType: "label",
        },

        usrStatCd: { type: "select", label: "L_USR_STAT", area: "comnCd", comnCd: "PTL0001" },
        usrStatCdNm: { type: "text", label: "L_USR_STAT" },

        cstmOfceCd: { type: "select", label: "L_CSTM_OFCE" },
        cstmOfceCdNm: { type: "text", label: "L_CSTM_OFCE" },

        cstmSctnOrgzCd: { type: "code", area: "orgzSub", label: "L_CSTM_SCTN", popupSize: "md" },
        cstmSctnOrgzCdNm: { type: "text", label: "L_CSTM_SCTN" },

        cstmUnitOrgzCd: { type: "select", label: "L_CSTM_UNIT" },
        cstmUnitOrgzCdNm: { type: "text", label: "L_CSTM_UNIT" },
        cstmOrgzTpCd: { type: "text", label: "L_CSTM_UNIT" },

        roleId: { type: "select", label: "L_ROLE_NM" },
        roleNm: { type: "text", label: "L_ROLE_NM" },
        actnUsrYn: {
            type: "radio",
            label: "L_BIDR",
            options: [
                { label: "L_CD_YES", value: "Y" },
                { label: "L_CD_NO", value: "N" },
            ],
            defaultValue: "N",
            viewType: "label",
        },

        ofcrStatCd: { type: "select", label: "L_OFCR_STAT", area: "comnCd", comnCd: "PTL0001" },
        ofcrStatCdNm: { type: "text", label: "L_OFCR_STAT" },

        mdfyRsn: { type: "textarea", label: "L_MDFY_RSN", controlSize: 10, rows: 5, maxLength: 2000 },
    },
};

export const SG_CSTM_OFCR_EXCEL_FORM: TGridSchema = {
    id: "grid_btchInfoList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_USR_ID", binding: "usrDmnId", width: "*" }] },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_OFCR_NO", binding: "cstmOfcrNo", width: "15%" }] },
        { cells: [{ header: "L_CSTM_SCTN", binding: "cstmSctnCdNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_OFCE", binding: "cstmNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_UNIT", binding: "cstmUnitCdNm", width: "*" }] },
        { cells: [{ header: "L_USR_STAT", binding: "usrStatCdNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "usrDmnId" }] },
        { cells: [{ binding: "usrNm", align: "left" }] },
        { cells: [{ binding: "cstmOfcrNo" }] },
        { cells: [{ binding: "cstmSctnCdNm", align: "left" }] },
        { cells: [{ binding: "cstmNm", align: "left" }] },
        { cells: [{ binding: "cstmUnitCdNm", align: "left" }] },
        { cells: [{ binding: "usrStatCdNm" }] },
    ],
};

export const SG_USR_CSTM_LIST: TGridSchema = {
    id: "grid_usrCstmList",
    options: { index: true, height: 150 },
    head: [
        { cells: [{ header: "L_CSTM", binding: "cstmCd", width: "*" }] },
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: 200 }] },
    ],
    body: [
        { cells: [{ binding: "cstmCd", type: "code", area: "cstmCd" }] },
        {
            cells: [
                {
                    binding: "useYn",
                    type: "radio",
                    align: "center",
                    viewType: "label",
                    options: [
                        { label: "L_CD_YES", value: "Y" },
                        { label: "L_CD_NO", value: "N" },
                    ],
                    copy: false,
                },
            ],
        },
    ],
};
